// extracted by mini-css-extract-plugin
export default {"batteryWrapper":"Battery_batteryWrapper__80IFq","batteryText":"Battery_batteryText__eFBBW","batteryIcon":"Battery_batteryIcon__Lry-D"};